import { makeStyles } from '@material-ui/core/styles'
import { colors } from 'src/components/app-ui'

const card = {
  background: '#FFFFFF',
  border: `1px solid ${colors.border}`,
  borderRadius: '12px',
}

const segmentedBase = {
  display: 'flex',
  padding: '3px',
  border: `1px solid ${colors.border}`,
  borderRadius: '8px',
  background: '#FFFFFF',
}

const useStyles = makeStyles({
  root: {
    display: 'flex',
    flexDirection: 'column',
    gap: '16px',
  },
  presetsCard: {
    ...card,
    display: 'flex',
    flexDirection: 'column',
    gap: '10px',
    padding: '14px 16px',
  },
  presetsHead: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    flexWrap: 'wrap',
    gap: '12px',
  },
  heading: {
    display: 'flex',
    alignItems: 'baseline',
    flexWrap: 'wrap',
    gap: '10px',
  },
  title: {
    fontSize: '15px',
    fontWeight: 600,
    color: colors.navy,
  },
  desc: {
    fontSize: '13px',
    color: colors.muted,
  },
  modified: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: '8px',
  },
  modifiedBadge: {
    padding: '2px 8px',
    borderRadius: '6px',
    background: '#FFF4E5',
    fontSize: '11px',
    fontWeight: 600,
    color: '#B26A00',
    textTransform: 'uppercase',
  },
  reset: {
    padding: '2px 4px',
    border: 0,
    background: 'transparent',
    cursor: 'pointer',
    fontFamily: 'inherit',
    fontSize: '12px',
    fontWeight: 500,
    color: colors.primary,
  },
  presets: {
    display: 'flex',
    gap: '10px',
    overflowX: 'auto',
    padding: '2px 2px 4px',
  },
  preset: {
    flex: '0 0 132px',
    display: 'flex',
    flexDirection: 'column',
    gap: '6px',
    padding: '4px',
    border: `1px solid ${colors.border}`,
    borderRadius: '10px',
    background: '#FFFFFF',
    cursor: 'pointer',
    fontFamily: 'inherit',
    textAlign: 'left',
  },
  presetOn: {
    border: `2px solid ${colors.primary}`,
    padding: '3px',
  },
  presetThumb: {
    width: '100%',
    height: 64,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: '7px',
    backgroundSize: 'cover',
    backgroundPosition: 'center',
  },
  presetCard: {
    width: '58%',
    height: 34,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    gap: '4px',
    padding: '0 7px',
    borderRadius: '5px',
    background: 'rgba(255,255,255,.85)',
  },
  presetLine: {
    height: 4,
    width: '70%',
    borderRadius: '2px',
  },
  presetLine2: {
    height: 3,
    width: '90%',
    borderRadius: '2px',
    background: 'rgba(0,0,0,.15)',
  },
  presetLabel: {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    padding: '0 4px 2px',
    fontSize: '12px',
    fontWeight: 500,
    color: colors.navy,
  },
  body: {
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'stretch',
    gap: '16px',
  },
  previewCard: {
    ...card,
    flex: '1 1 380px',
    minWidth: 0,
    overflow: 'hidden',
  },
  previewHead: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    flexWrap: 'wrap',
    gap: '12px',
    padding: '14px 20px',
    borderBottom: `1px solid ${colors.border}`,
  },
  previewMeta: {
    fontSize: '12px',
    color: colors.muted,
  },
  previewStage: {
    display: 'flex',
    justifyContent: 'center',
    padding: '16px',
    background: colors.hover,
  },
  previewFrame: {
    width: '100%',
    maxWidth: 640,
    minHeight: 380,
    display: 'flex',
    overflow: 'hidden',
    border: `1px solid ${colors.border}`,
    borderRadius: '10px',
  },
  rail: {
    width: 120,
    flex: 'none',
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
    padding: '16px 14px',
    borderRight: '1px solid rgba(0,0,0,.06)',
    background: 'rgba(255,255,255,.55)',
  },
  railTitle: {
    marginBottom: 4,
    fontSize: '11px',
    fontWeight: 600,
    opacity: 0.7,
  },
  railItem: {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    padding: '5px 8px',
    borderRadius: '6px',
    fontSize: '11px',
  },
  stage: {
    flex: 1,
    minWidth: 0,
    display: 'flex',
    flexDirection: 'column',
  },
  dots: {
    display: 'flex',
    gap: '6px',
    padding: '14px 20px 0',
  },
  dot: {
    flex: 1,
    height: 4,
    borderRadius: '2px',
  },
  stageBody: {
    flex: 1,
    display: 'flex',
    justifyContent: 'center',
    gap: '14px',
    padding: '20px',
  },
  arrow: {
    width: 26,
    height: 26,
    flex: 'none',
    alignSelf: 'center',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: '50%',
    boxShadow: '0 1px 3px rgba(0,0,0,.15)',
  },
  page: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    gap: '10px',
    padding: '22px 24px',
    borderRadius: '10px',
    boxShadow: '0 8px 24px rgba(0,0,0,.08)',
  },
  pageTitle: {
    fontWeight: 700,
    letterSpacing: '-.01em',
    lineHeight: 1.2,
  },
  pageText: {
    lineHeight: 1.55,
    opacity: 0.85,
  },
  pageMedia: {
    height: 64,
    borderRadius: '6px',
  },
  continue: {
    alignSelf: 'flex-start',
    display: 'inline-flex',
    alignItems: 'center',
    gap: '6px',
    marginTop: 4,
    padding: '8px 18px',
    borderRadius: '8px',
    fontWeight: 600,
    color: '#FFFFFF',
  },
  bar: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    margin: '0 20px 16px',
    padding: '8px 12px',
    borderRadius: '8px',
    background: 'rgba(255,255,255,.7)',
    fontSize: '11px',
  },
  barButtons: {
    display: 'flex',
    gap: '6px',
  },
  barButton: {
    width: 22,
    height: 22,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: '50%',
  },
  settingsWrap: {
    flex: '0 0 280px',
    minWidth: 0,
    position: 'relative',
    minHeight: 440,
  },
  settings: {
    ...card,
    position: 'absolute',
    inset: 0,
    display: 'flex',
    flexDirection: 'column',
    overflow: 'hidden',
  },
  settingsScroll: {
    flex: 1,
    minHeight: 0,
    overflowY: 'auto',
    display: 'flex',
    flexDirection: 'column',
    gap: '18px',
    padding: '18px 18px 24px',
  },
  settingsFoot: {
    flex: 'none',
    display: 'flex',
    padding: '14px 18px',
    borderTop: `1px solid ${colors.border}`,
    background: '#FFFFFF',
  },
  apply: {
    flex: 1,
    padding: '10px 16px',
    border: 0,
    borderRadius: '8px',
    background: colors.primary,
    cursor: 'pointer',
    fontFamily: 'inherit',
    fontSize: '14px',
    fontWeight: 500,
    color: '#FFFFFF',
    '&:hover': {
      background: colors.primaryDark,
    },
    '&:disabled': {
      cursor: 'default',
      opacity: 0.6,
    },
  },
  field: {
    display: 'flex',
    flexDirection: 'column',
    gap: '6px',
  },
  label: {
    fontSize: '11px',
    fontWeight: 600,
    letterSpacing: '.06em',
    textTransform: 'uppercase',
    color: colors.subtle,
  },
  segmented: segmentedBase,
  segment: {
    flex: 1,
    padding: '6px 0',
    border: 0,
    borderRadius: '6px',
    background: 'transparent',
    cursor: 'pointer',
    fontFamily: 'inherit',
    fontSize: '13px',
    fontWeight: 500,
    color: colors.navy,
  },
  segmentOn: {
    background: colors.hover,
    boxShadow: 'inset 0 0 0 1px rgba(0,46,71,.12)',
  },
  swatches: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: '8px',
  },
  swatch: {
    width: 28,
    height: 28,
    padding: 0,
    border: `1px solid ${colors.border}`,
    borderRadius: '8px',
    cursor: 'pointer',
  },
  swatchOn: {
    border: `2px solid ${colors.primary}`,
    boxShadow: '0 0 0 2px #FFFFFF inset',
  },
  swatchCustom: {
    width: 28,
    height: 28,
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: 0,
    border: `1px dashed ${colors.subtle}`,
    borderRadius: '8px',
    background: '#FFFFFF',
    cursor: 'pointer',
    color: colors.muted,
  },
  picker: {
    position: 'absolute',
    top: '100%',
    left: 0,
    right: 0,
    zIndex: 6,
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
    marginTop: 6,
    padding: '10px',
    border: `1px solid ${colors.border}`,
    borderRadius: '10px',
    background: '#FFFFFF',
    boxShadow:
      '0 12px 24px -4px rgba(145,158,171,.24), 0 0 2px rgba(145,158,171,.2)',
  },
  pickerColor: {
    width: '100%',
    height: 84,
    padding: 0,
    border: 0,
    background: 'transparent',
    cursor: 'pointer',
  },
  pickerRow: {
    display: 'flex',
    alignItems: 'center',
    gap: '6px',
  },
  pickerLabel: {
    fontSize: '12px',
    color: colors.muted,
  },
  pickerHex: {
    flex: 1,
    minWidth: 0,
    padding: '6px 8px',
    border: `1px solid ${colors.borderSoft}`,
    borderRadius: '6px',
    outline: 'none',
    fontFamily: 'ui-monospace, Menlo, monospace',
    fontSize: '13px',
    color: colors.navy,
  },
  pickerDone: {
    padding: '6px 10px',
    border: 0,
    borderRadius: '6px',
    background: colors.primary,
    cursor: 'pointer',
    fontFamily: 'inherit',
    fontSize: '12px',
    fontWeight: 500,
    color: '#FFFFFF',
  },
  layouts: {
    display: 'grid',
    gridTemplateColumns: 'repeat(4, minmax(0, 1fr))',
    gap: '6px',
  },
  layout: {
    height: 56,
    display: 'flex',
    alignItems: 'stretch',
    gap: '4px',
    padding: '6px',
    border: `1px solid ${colors.border}`,
    borderRadius: '8px',
    background: '#FFFFFF',
    cursor: 'pointer',
  },
  layoutOn: {
    border: `2px solid ${colors.primary}`,
    padding: '5px',
  },
  layoutRail: {
    width: '22%',
    display: 'flex',
    flexDirection: 'column',
    gap: '3px',
    padding: '4px 3px',
    borderRadius: '3px',
    background: colors.border,
  },
  layoutRailLine: {
    height: 3,
    borderRadius: '2px',
    background: '#C4CBD3',
  },
  layoutMain: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '3px',
  },
  layoutTop: {
    width: '100%',
    display: 'flex',
    gap: '3px',
  },
  layoutTopLine: {
    flex: 1,
    height: 3,
    borderRadius: '2px',
    background: '#D0D5D9',
  },
  layoutPage: {
    flex: 1,
    borderRadius: '3px',
    background: colors.border,
  },
  layoutFoot: {
    height: 5,
    borderRadius: '2px',
    background: '#D0D5D9',
  },
  upload: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: '8px',
    padding: '14px 10px',
    border: '1.5px dashed #CBD0D7',
    borderRadius: '10px',
    background: '#FBFBFB',
    cursor: 'pointer',
    textAlign: 'center',
  },
  uploadHint: {
    fontSize: '12px',
    color: colors.muted,
  },
  uploadButton: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: '6px',
    padding: '6px 12px',
    border: '1px solid rgba(1,95,251,.5)',
    borderRadius: '8px',
    background: '#FFFFFF',
    fontSize: '13px',
    fontWeight: 500,
    color: colors.primary,
  },
  imageRow: {
    display: 'flex',
    alignItems: 'center',
    gap: '10px',
    padding: '8px',
    border: `1px solid ${colors.border}`,
    borderRadius: '10px',
  },
  imageThumb: {
    width: 44,
    height: 44,
    flex: 'none',
    borderRadius: '6px',
    background: `${colors.hover} center / cover no-repeat`,
  },
  imageName: {
    flex: 1,
    minWidth: 0,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    fontSize: '12px',
    color: colors.navy,
  },
  imageRemove: {
    padding: '4px',
    border: 0,
    background: 'transparent',
    cursor: 'pointer',
    fontFamily: 'inherit',
    fontSize: '12px',
    fontWeight: 500,
    color: '#C9383B',
  },
  stretchRow: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    gap: '12px',
  },
  stretchTitle: {
    fontSize: '14px',
    fontWeight: 500,
    color: colors.navy,
  },
  stretchDesc: {
    marginTop: 2,
    fontSize: '12px',
    color: colors.muted,
  },
})

export default useStyles
